export const CLOSE_DURATION_FILTER = "CLOSE_DURATION_FILTER";
export const OPEN_DURATION_FILTER = "OPEN_DURATION_FILTER";
